<template>
    <div class="page-loadmore-wrapper" ref="wrapper">
        <div :style="wrapperStyle">
            <ul class="page-loadmore-list">
                <slot></slot>
            </ul>
            <div class="mint-loadmore-bottom" data-skeleton-remove slot="bottom">
                <template v-if="error">
                    <p @click="emitResend" class="bottom-error-text">{{ errorText }}</p>
                </template>
                <template v-else-if="showBtn">
                    <span :data-log="formatTjData()" @click="clickShowMore" class="show-more" v-intersection
                        >查看更多商品</span
                    >
                </template>
                <template v-else-if="loadText === 'loading'">
                    <img class="scroll-loading" src="../../assets/image/loading.gif" />
                </template>
                <template v-else>
                    <i
                        class="page-loadmore-icon-empty"
                        :class="emptySty > 0 ? 'sty' + emptySty : ''"
                        v-if="isShowEmpty"
                    ></i>
                    <span :data-log="formatTjData()" v-intersection>{{ loadText }}</span>
                </template>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.page-loadmore-listitem {
    height: 50px;
    line-height: 50px;
    text-align: center;
}
.mint-loadmore-bottom {
    background: #f7f7f7;
    // height: 0.5rem;
    color: #999;
    line-height: 0.5rem;
    text-align: center;
    font-size: 0.28rem;
    padding-bottom: 0.4rem;

    .show-more {
        width: 2.44rem;
        height: 0.6rem;
        line-height: 0.6rem;
        color: #fff;
        font-size: 0.28rem;
        background: #ddc47d;
        border-radius: 0.04rem;
        display: inline-block;
        margin: 0.22rem auto 0.4rem;
    }
}
.page-loadmore-wrapper {
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 0.2rem;
    padding-bottom: calc(0.2rem + env(safe-area-inset-bottom));
    padding-bottom: constant(0.2rem + constant(safe-area-inset-bottom));
}

.bottom-error-text {
    padding-bottom: 0.6rem;
}
.scroll-loading {
    width: 0.6rem;
}
.page-loadmore-icon-empty {
    width: 1.75rem;
    height: 1.85rem;
    background-image: url(../../assets/image/icon-empty.png);
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    margin: 1.92rem auto 0.4rem;
    display: block;
    margin-top: 1.92rem;
    margin-bottom: 0.4rem;
    &.sty1 {
        margin-top: 3rem;
        width: 2.2rem;
        background-image: url('../../views/freeBuy/images/empty.png');
    }
}
</style>

<script>
import useContext from 'root/common/util/context';

const ZZCFL = window.ZZCFL;
/**
 * 获取滚动元素
 * @param  {[type]} el [description]
 * @return {[type]}    [description]
 */
function get_scroll_target(el) {
    while (el.nodeType === 1 && el.tagName !== 'BODY' && el.tagName !== 'HTML') {
        var overflowY = getComputedStyle(el).overflowY;
        if (overflowY === 'scroll' || overflowY === 'auto') {
            return el;
        }
        el = el.parentNode;
    }

    return window;
}

export default {
    mixins: [useContext({ useKeys: ['tjLocation'] })],
    props: {
        wrapperStyle: {
            type: Object,
        },
        loadText: {
            type: String,
        },
        showBtn: {
            default: false,
        },
        loading: {
            default: true,
        },
        loaded: {
            default: false,
        },
        error: {
            default: false,
        },
        errorText: {
            default: '网络错误，请点击重试',
        },
        needLoadText: {
            default: true,
        },
        el: {},
        container: {
            default: '',
        },
        needSecondLoad: {
            default: false,
        },
        tjObjId: {
            default: '',
        },
        // 曝光显示的页面标记，如首页是home
        tjPageTag: {
            default: '',
        },
        // 曝光显示的平台
        tjMallType: {
            default: '',
        },
        tjExtendData: {
            default: function() {
                return {};
            },
        },
        tjCatId: {
            default: undefined,
        },
        isShowEmpty: {
            default: false,
        },
        emptySty: {
            default: false,
            type: Boolean,
        },
        id: {},
    },
    data() {
        return {
            wrapperHeight: 0,
        };
    },
    methods: {
        loadMore() {
            this.$emit('scrolltoend');
        },
        clickShowMore() {
            this.$emit('clickshowmore');
        },
        scroll() {
            const self = this;
            if (self.$el.nodeType !== 1) {
                return;
            }

            // var vm = self.vm;
            var target = (self.target = get_scroll_target(self.$el));
            var childView = document.querySelector('#viewpage');

            if (childView && ZZCFL.Utils.UA.browser.name === 'black') {
                switch (getComputedStyle(childView).position) {
                    case 'absolute':
                        target = childView;
                        break;
                    case 'static':
                    case 'inherit':
                        target = window;
                        break;
                }
                // 特殊处理app
                if (ZZCFL.Utils.UA.os.name === 'android') {
                    target = self.$el;
                }
            }
            if (self.container) {
                switch (self.container) {
                    case 'window':
                        target = window;
                        break;
                    case 'cur-child':
                        target = self.$el;
                        break;
                    default:
                        target = self.container;
                }
            }

            // 特殊处理不够一屏的
            if (self.needSecondLoad) {
                self.loadMore();
            }

            this.target = target;
            target.addEventListener('scroll', () => this.checkLoad());
        },
        checkLoad() {
            const target = this.target;
            let _scrollTop = target.scrollTop;
            if (typeof _scrollTop === 'undefined') {
                _scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            }

            if (this.loadText !== 'loading' && this.needLoadText) {
                this.$emit('scroll', _scrollTop, this.id);
                return;
            }
            if (!this.$el.clientHeight) {
                return;
            }

            if (this.$el && this.$el.getBoundingClientRect().x >= window.innerWidth) {
                return;
            }
            if (target == window) {
                var scrll_top = Math.max(
                    window.pageYOffset || 0,
                    document.documentElement.scrollTop || document.body.scrollTop
                );
                if (window.innerHeight + scrll_top >= document.documentElement.scrollHeight - 30) {
                    this.loadMore();
                }
            } else {
                if (target.clientHeight + target.scrollTop >= target.scrollHeight - 30) {
                    this.loadMore();
                }
            }
            this.$emit('scroll', _scrollTop, this.id);
        },

        // 网络环境差，加载失败
        emitResend() {
            this.$emit('resend');
        },
        formatTjData() {
            let data = {};

            if (window.bigTj) {
                data = {
                    obj_id: this.tjObjId,
                    obj_type: this.tjMallType,
                    cat_id: this.tjCatId,
                    ...(this.context$.tjLocation || {}),
                };
            }

            return JSON.stringify(data);
        },
    },
    mounted() {
        this.scroll();
    },
    components: {
        //InfiniteScroll
    },
};
</script>
